import { useAsync, type UseAsyncReturn } from 'react-async-hook';
import api from '../common/api';
import type { FacilityNumber } from '@reliance/types/models/FacilityNumber';

export type FacilityNumberEditable = Omit<FacilityNumber, 'id' | 'facility'> & {
  id?: number;
  facility?: FacilityNumber['facility'];
};

function normalizeRow(raw: FacilityNumberEditable & { id?: number }): FacilityNumberEditable {
  return {
    id: raw.id,
    ani: raw.ani ?? '',
    numberType: raw.numberType ?? 1,
    active: raw.active ?? true,
    facility: raw.facility,
  };
}

/**
 * Loads outbound numbers for a facility (`GET /facility/:id/number`).
 * Call `execute(facilityId)` to refresh.
 */
export function useFacilityNumbersList(
  facilityId: number | undefined
): UseAsyncReturn<FacilityNumberEditable[], [number | undefined]> {
  return useAsync(
    async (): Promise<FacilityNumberEditable[]> => {
      if (facilityId == null) {
        return [];
      }
      const res = await api.get<FacilityNumberEditable[]>(`/facility/${facilityId}/number`);
      const list = res.data ?? [];
      return list.map((row) => normalizeRow(row));
    },
    [facilityId]
  );
}
